/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetSiteResponseData,
  GetSiteResponseDataFromJSON,
  GetSiteResponseDataFromJSONTyped,
  GetSiteResponseDataToJSON
} from './GetSiteResponseData'

/**
 *
 * @export
 * @interface PublishSiteResponse
 */
export interface PublishSiteResponse {
  /**
   *
   * @type {number}
   * @memberof PublishSiteResponse
   */
  status?: number
  /**
   *
   * @type {GetSiteResponseData}
   * @memberof PublishSiteResponse
   */
  data?: GetSiteResponseData
}

export function PublishSiteResponseFromJSON(json: any): PublishSiteResponse {
  return PublishSiteResponseFromJSONTyped(json, false)
}

export function PublishSiteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublishSiteResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetSiteResponseDataFromJSON(json['data'])
  }
}

export function PublishSiteResponseToJSON(value?: PublishSiteResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetSiteResponseDataToJSON(value.data)
  }
}
